



















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi, VehicleLocation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { ValidationRules } from '@/helper/enum';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    // components: {
    //   AppDialog: () => import('@/components/common/app.dialog.vue'),
    // },
})
export default class PayrocAddTerminalPage extends Base {
    public storeViewModel: any = {};
    public storeModel: StoreModel = {};

    public terminalModel: any = {};
    public selectedLocation: string = '';
    public form: any = {};
    public devicePairLocationFields: Array<VFields<any>> = [];
    public storeId: number = 0;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public requestProgress: boolean = false;
    public deviceCode = '';
    public locationName = '';

    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router
                .push({
                    name: 'admin.stores.edit',
                    params: { id: this.storeId.toString(), tab: 'PayrocAccount' },
                })
                .catch((ex) => {
                    console.log(ex);
                });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(
                    false,
                    this.$t('stores.vehicleLocations.alertInvalidForm')
                );
                this.resetMethodName(methodName);
                return;
            }
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        if (this.storeId) {
            buttons.push({
                id: '0',
                type: 'button',
                title: this.$parent.$t('stores.btnBackToStoreTitle'),
                disabled: false,
                visible: true,
                class: 'btn',
                label: this.$parent.$t('stores.btnBack'),
                click: 'backToStoreEdit',
                icon: 'fas fa-arrow-left',
            });
        }
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        this.setLocationFields();
        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
            // this.getStoreInfo();
        }

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
    }

    public setLocationFields(): void {
        this.devicePairLocationFields = [
            {
                key: 'serialNumber',
                required: false,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: false,
                    label: 'Serial Number',
                    counter: 80,
                    loading: false,
                    rules: [
                        v => this.required('Serial Number', v)
                    ]
                },
            },
            {
                key: 'processingTerminalId',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Processing TerminalId',
                    counter: 80,
                    loading: false,
                    rules: [
                        v => this.required('Processing TerminalId', v)
                    ]
                },
            },
            {
                key: 'deviceFriendlyName',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Device Friendly Name',
                    counter: 80,
                    loading: false,
                    rules: [
                        v => this.required('Device Friendly Name', v)
                    ]
                },
            },
        ];
    }

    public validateDevicePair(): Vue & { validate: () => boolean } {
        return this.$refs.payrocAddTerminalForm as Vue & { validate: () => boolean };
    }

    public async savePayrocAddTerminal(): Promise<void> {
        if (this.validateDevicePair().validate()) {
            try {
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);

                const res = await storeService.payrocTerminalSetup(
                    this.terminalModel.serialNumber,
                    this.terminalModel.processingTerminalId,
                    this.terminalModel.deviceFriendlyName,
                    this.storeId
                );

                if (res.status) {
                    this.showAlert(true, 'New terminal added successfully');
                    this.$router
                        .push({
                            name: 'admin.stores.edit',
                            params: {
                                tenantId: this.tenantId.toString(),
                                enterpriseId: this.enterpriseId.toString(),
                                storeId: this.storeId.toString(),
                                tab: 'PayrocAccount'
                            },
                        });
                } else {
                    this.showAlert(false, res.response);
                }
            } finally {
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
            }
        }
    }
}
